import { appBusIcon } from './bus';
import { appGlobe01Icon } from './globe-01';
import { appMarkIcon } from './mark';
import { appPlaneIcon } from './plane';
import { appRouteIcon } from './route';
import { appTicket01Icon } from './ticket-01';
export const mapsIcons = [appBusIcon, appGlobe01Icon, appMarkIcon, appPlaneIcon, appRouteIcon, appTicket01Icon];
